angular.module('bmsApp.accounting')
	.controller('PaymentReceiptModalCtrl', [
		'$scope',
		'$modalInstance',
		'$ngBootbox',
		'customer',
		'invoicePrototype',
		'additionalInvoicePrototype',
		function ($scope,
				  $modalInstance,
				  $ngBootbox,
				  customer,
				  invoicePrototype,
				  additionalInvoicePrototype) {

		console.info(customer);

			$scope.prModal = {
				instance: $modalInstance,
				customer: customer,
				invoicePrototype: invoicePrototype,
				additionalInvoicePrototype: additionalInvoicePrototype,
				cancel: function () {
					$ngBootbox.confirm('Are you sure you want to do this?')
						.then(function () {
							$modalInstance.dismiss('cancel');
						});
				}
			};

			$scope.prForm = {};

		}
	]);
